module.exports = __webpack_public_path__ + "static/media/loading_beekeeper.26f2015a.gif";